import React, {useEffect} from 'react';
import Button from "@mui/material/Button";
import {useUpdateCompetitionRegistrationMutation} from "../../slices/apiSlice";

const WildcardWidget = ({entry, hasWildcardAvailable, onUpdate = ()=>{}}) => {
    const [isWildcard, setIsWildcard] = React.useState(entry.registration.n === 'wildcard')

    const [update, updateResult] =useUpdateCompetitionRegistrationMutation()

    const handleClick = () => {
        update({
            eventId: entry.registration.j,
            id: entry.registration.i,
            data11: isWildcard ? '' : 'wildcard',
        })
        setIsWildcard(!isWildcard)
    }

    useEffect(() => {
        if (updateResult.isSuccess){
            if (onUpdate && updateResult.data.status === "ok") onUpdate(updateResult.data.data)
        }
    }, [updateResult]);

    return (
        <>
            {(isWildcard || hasWildcardAvailable) &&
                <Button
                    variant={'contained'}
                    onClick={handleClick}
                    size={'small'}>
                    { isWildcard ? 'Remove wildcard' : 'Make wildcard'}
                </Button>
            }
        </>
    )
}

export default WildcardWidget;